"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericsToTypes = void 0;
const genericsToTypes = ({ schemaFields, model, }) => {
    Object.entries(schemaFields).map(([key, field]) => {
        const data = model[key];
        if (data != undefined && data != null) {
            const typeOfData = typeof data;
            if (field.type == 'number' && typeOfData != 'number') {
                model[key] = Number(data);
            }
            else if (field.type == 'boolean' && typeOfData != 'boolean') {
                model[key] = data == 1;
            }
            else if (field.type == 'date' && typeOfData == 'string') {
                const isFim = key.toLocaleLowerCase().indexOf('fim') >= 0 || key.toLocaleLowerCase().indexOf('final') >= 0;
                let dataStr = String(data);
                const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/gm;
                const matchArray = regex.exec(dataStr);
                if (matchArray && matchArray.length > 0) {
                    const dia = matchArray[1];
                    const mes = matchArray[2];
                    const ano = matchArray[3];
                    if (ano && mes && dia) {
                        dataStr = `${ano}-${mes}-${dia}`;
                    }
                }
                const finalDay = 'T23:59:59.000+00:00';
                const initDay = 'T00:00:00.000+00:00';
                model[key] = new Date(dataStr.concat(dataStr.length == 10 ? (isFim ? finalDay : initDay) : ''));
            }
        }
    });
    return model;
};
exports.genericsToTypes = genericsToTypes;
